import MissionController from "./mission-controller";

export {MissionController};
